<template>
    <v-container grid-list-md pa-0 relative>
        <v-layout row wrap>
            <v-flex xs12 sm12>
                <v-card outlined class="primary--border">
                    <v-card-title class="title">
                        Student Behaviour

                    </v-card-title>
                    <v-card outlined>
                        <v-card-title class="title pb-0">

                            <v-flex xs1 sm2>
                                <v-calendar-field id-val="student_behaviour_submit_date" v-model="form.submitted_date" label="Date">
                                </v-calendar-field>
                            </v-flex>
                            <v-flex xs3 sm2>
                                <v-select @change="getSections(), getSubjects()" :items="grades" class="pa-0"
                                    label="Select grade" outlined dense v-model="form.grade_id" />
                            </v-flex>

                            <v-flex xs2 sm1>
                                <v-select outlined dense :disabled="sections.length < 1" :items="sections" class="pa-0"
                                    label="Section" v-model="form.section_id" />
                            </v-flex>
                            <v-flex xs2 sm2>
                                <v-select :items="subjects" class="pa-0" label="Select Subjects"
                                    v-model="form.subject_id" :disabled="!form.grade_id" :loading="subjectLoading"
                                    outlined dense />
                            </v-flex>
                            <v-flex xs2 sm2>
                                <v-select :items="remark_group_type" class="pa-0" label="Select Remark Type"
                                    v-model="form.remark_label_type" :disabled="!form.grade_id" @change="getRemarkLables()"
                                    outlined dense />
                            </v-flex>
                            <v-flex xs2 sm2>
                                <v-select :items="remarkLabels" class="pa-0" label="Select Remark Label"
                                    v-model="form.remark_label_id" :disabled="!form.remark_label_type" 
                                    outlined dense />
                            </v-flex>
                            <v-flex xs1 sm1>
                                <search-button  :permission="true" :disabled="!form.grade_id || !form.section_id || !form.subject_id || !form.remark_label_id"
                                    @action="get()">
                                </search-button>
                            </v-flex>

                        </v-card-title>
                        <v-data-table 
                            hide-default-footer
                            :headers="headers" 
                            :items="student_behaviour_lists" 
                            :options.sync="pagination"
                            :footer-props="footerProps" 
                            :server-items-length="student_behaviour_lists.length"

                            :loading="formLoading">
                            <template v-slot:item="{ index, item }">
                                <tr>
                                    <td>{{ ++index }}</td>
                                    <td class="text-xs-left">{{ item.name }}
                                        
                                    </td>
                                    <td class="text-xs-left"> {{ item.roll   }}</td>
                                    <td class="text-xs-left"> {{ item.enroll_code }}</td>
                                    <!-- <td class="text-xs-left"> 
                                         {{ item.grade }} <sup>{{ item.section }}</sup>
                                    </td> -->
                                    <!-- <td class="text-xs-right">
                                        
                                       <v-rating
                                            style="float: right;"
                                            :readonly="!form.remark_label_id"
                                            v-model="item.rating"
                                            :color="form.remark_label_type === 'negative' ? 'red' : 'green'"
                                            background-color="grey lighten-1"
                                            medium
                                            dense
                                            clearable
                                            length="5"
                                            @input="markRatingModified(item, $event)"
                                        ></v-rating>
                                      

                                    </td> -->
                                    <td class="text-xs-right" >
                                        <div style="display: flex; flex-direction: column; align-items: flex-end; margin-top: 5px;">
                                            <v-btn
                                            v-if="index === 1"
                                            style="min-width: unset !important;"
                                            small
                                            color="primary"
                                            outlined
                                            @click="copyToAll(item.rating)"
                                            >
                                            copy to all
                                            </v-btn>

                                            <v-rating
                                            :readonly="!form.remark_label_id"
                                            v-model="item.rating"
                                            :color="form.remark_label_type === 'negative' ? 'red' : 'green'"
                                            background-color="grey lighten-1"
                                            medium
                                            dense
                                            clearable
                                            length="5"
                                            @input="markRatingModified(item, $event)"
                                            ></v-rating>
                                        </div>
                                        </td>
                                </tr>
                            </template>
                        </v-data-table>
                       
                        <v-card-actions class="pa-4" v-if="modifiedRemarks.length >0 && form.submitted_date && form.remark_label_id && form.grade_id && form.section_id && form.subject_id">
                            <v-spacer></v-spacer>
                            <v-btn  block color="primary" :disabled="loading" :loading="loading" large @click="submitRatings">Save Rating</v-btn>
                        </v-card-actions>

                    </v-card>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="remarksDialog" persistent max-width="500px">
            <v-card>
            <v-card-title class="title primary white--text"
                >Remarks</v-card-title
            >
            <v-card-text class="mt-5">
                <v-textarea
                label="Remarks"
                v-model="form.remark"
                color="error"
                outlined
                dense
                />
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn color="error" text outlined @click="remarksDialog = false"
                >Cancel</v-btn
                >
                <v-btn color="success" text outlined @click="submitRatings()"
                >OK</v-btn
                >
            </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>

</template>

<script>

import Form from "@/library/Form";
import { mapState } from "vuex";
// import Mixins from "@/library/Mixins";
import Mixins from "../../../../library/Mixins";


const NepaliDate = require("nepali-date-js");
const dt = new NepaliDate();

export default {
    mixins: [Mixins],
    data: () => ({

        form: new Form(
            {
                enroll_id: '',
                grade_id: '',
                teacher_id: '',
                subject_id: '',
                submitted_date: dt.format("YYYY-MM-DD"),
                section_id: '',
                remark_label_id: '',
                remark: '',
                remark_label_type: '',


            },
            // "/api/app-student-remark"
        ),
        formLoading: false,
        remarksDialog: false,
        student_behaviour_lists: [],
        sections: [],
        grades: [],
        subjects: [],
        gradeLoading: false,
        batchId: "",
        subjectLoading: false,
        headers: [
            { text: "#", align: "left", value: "id", width: 50, sortable: false },
            { text: "Name", align: "left", value: "name", sortable: false },
            { text: "Roll", align: "left", value: "roll", sortable: false },
            { text: "Enroll Code", align: "left", value: "enroll_code", sortable: false },
            // { text: "Grade", align: "left", value: "grade_section", sortable: false },
            { text: "Rating", align: "right", value: "rating", sortable: false },
        ],
        remarkLabels: [],
        modifiedRatings: [],

        modifiedRemarks: [],
        loading: false,

        remark_group_type: [
            {text: 'Positive', value: 'positive'},
            {text: 'Negative', value: 'negative'}
        ]



    }),

    mounted() {
        this.getGrades()
    },
    computed: {
        ...mapState(["batch"])

    },
    watch:{
        pagination: function () {
            if(this.form.grade_id || this.form.section_id) {
                this.get();
            }
        },
        'form.grade_id'(val) {
            this.student_behaviour_lists = [];
            this.form.section_id = '';
            this.form.subject_id = '';
            this.form.remark_label_id = '';
            this.sections = [];
            this.subjects = [];
            this.remarkLabels = [];
            this.modifiedRemarks = [];
            this.remark_label_type = '';
        },
        'form.section_id'(val) {
            this.student_behaviour_lists = [];
            this.modifiedRemarks = [];
            this.remark_label_type = '';

        },
        'form.subject_id'(val) {
            this.student_behaviour_lists = [];
            this.modifiedRemarks = [];
            this.remark_label_type = '';

        },
        'form.remark_label_id'(val) {
            this.student_behaviour_lists = [];
            this.modifiedRemarks = [];
            this.remark_label_type = '';

            
        },
        'form.remark_label_type'(val) {
            this.student_behaviour_lists = [];
            this.modifiedRemarks = [];
            this.remark_label_type = '';

        },
        'form.submitted_date'(val) {
            this.student_behaviour_lists = [];
            this.modifiedRemarks = [];
            this.remark_label_type = '';

        },
       

    },
    methods: {

        get() {
            this.formLoading = true
            this.student_behaviour_lists = [];
            let extraParams =
                "grade_id=" +
                this.form.grade_id +
                "&section_id=" + this.form.section_id +
                "&submitted_date=" + this.form.submitted_date +
                "&subject_id=" + this.form.subject_id+
                "&remark_label_id="+ this.form.remark_label_id+
                "&rowsPerPage="+this.pagination.itemsPerPage

            this.$rest.get('/api/app-student-behaviuor-remark?'+extraParams).then((res) => {
                this.student_behaviour_lists = res.data
            }).finally(() => {
                this.formLoading = false
            })


        },
        getGrades() {
            this.$rest
                .get("/api/grades?rowsPerPage=20&sortBy=rank&descending=false&slim=true")
                .then(({ data }) => {
                    this.grades = data.data.map((item) => {
                        return { value: item.id, text: item.name };
                    });
                });
        },
        getSections() {
            this.$rest.get(
                "/api/section?batch=" +
                this.batchId +
                "&grade=" +
                this.form.grade_id
            )
                .then(({ data }) => {
                    this.sections = data.data.map((item) => {
                        return { value: item.id, text: item.name };
                    });
                });
        },
        getSubjects() {
            this.subjectLoading = true;
            this.$rest.get(
                "/api/subject?rowsPerPage=25&grade=" +
                this.form.grade_id +
                "&batch=" +
                this.batch.id
            ).then(({ data }) => {
                this.subjects = [];
                // this.subjects.push({ value: "", text: "All Subjects" });
                data.data.map((item) => {
                    this.subjects.push({ value: item.id, text: item.name });
                });
            })
            .finally(() => {
                this.subjectLoading = false;
            });
        },
        getRemarkLables(){
            this.$rest.get('/api/remark-labels?grade_id'+this.form.grade_id+"&rowsPerPage=50"+"&group_type="+this.form.remark_label_type).then((res) => {
                this.remarkLabels = res.data.data.map((item)=> {
                    return {text: item.title, value: item.id, group_type: item.group_type}
                })

            })
        },
       markRatingModified(item, newValue) {
            item.rating = newValue;

            const existingIndex = this.modifiedRemarks.findIndex(
                (r) => r.enroll_id === item.enroll_id
            );

            const remarkObject = {
                enroll_id: item.enroll_id,
                enroll_code: item.enroll_code,
                rating: item.rating,
                remarks: item.remarks,
            };

            if (existingIndex !== -1) {
                this.modifiedRemarks.splice(existingIndex, 1, remarkObject);
            } else {
                this.modifiedRemarks.push(remarkObject);
            }

        //     if (item.rating === newValue) {
        //         item.rating = 0;
        //     } else {
        //         item.rating = newValue;
        //     }
        //    const existingIndex = this.modifiedRemarks.findIndex(
        //         (r) => r.enroll_id === item.enroll_id
        //     );

        //     const remarkObject = {
        //         enroll_id: item.enroll_id,
        //         enroll_code: item.enroll_code,
        //         rating: item.rating,
        //         remarks: item.remarks
        //     };

        //     if (existingIndex !== -1) {
        //         // Update existing record
        //         this.modifiedRemarks.splice(existingIndex, 1, remarkObject);
        //     } else {
        //         // Add new record
        //         this.modifiedRemarks.push(remarkObject);
        //     }
            
        },

        submitRatings(){

            if(!this.$auth.user().id) return this.$events.fire("notification", {
                message: 'No user id available',
                status: "error",
            });
            this.loading = true
            this.$rest.post('/api/app-student-behaviuor-remark', {
                'remark_label_id': this.form.remark_label_id,
                'submitted_date': this.form.submitted_date,
                'subject_id': this.form.subject_id,
                'teacher_id': this.$auth.user().id,
                'remarks': this.modifiedRemarks
                
            }).then((res) => {
                this.$events.fire("notification", {
                    message: res.data.message,
                    status: "success",
                });
                this.modifiedRemarks = []
                this.get();
            }).finally(() => {
                this.loading = false
            })
        },
        copyToAll(ratingValue){
            this.student_behaviour_lists = this.student_behaviour_lists.map((student) => {
                student.rating = ratingValue;

                const remarkObject = {
                enroll_id: student.enroll_id,
                enroll_code: student.enroll_code,
                rating: ratingValue,
                remarks: student.remarks
                };

                const existingIndex = this.modifiedRemarks.findIndex(
                (r) => r.enroll_id === student.enroll_id
                );

                if (existingIndex !== -1) {
                this.modifiedRemarks.splice(existingIndex, 1, remarkObject);
                } else {
                this.modifiedRemarks.push(remarkObject);
                }

                return student;
            });
        }
    }

}

</script>